import { render, staticRenderFns } from "./ProjectsImpactView.vue?vue&type=template&id=72e41b20&scoped=true&"
import script from "./ProjectsImpactView.vue?vue&type=script&lang=js&"
export * from "./ProjectsImpactView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e41b20",
  null
  
)

export default component.exports